/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { SliceName } from '../constants';

export const policySlice = createSlice({
  name: SliceName.Policy,
  initialState: {
    email: '',
    orderNumber: '',
    firstName: '',
    platform: '',
    policyList: [],
    claimList: [],
    reasonList: [],
    behaviorData: {},
    specialPlatform: '',
  },
  reducers: {
    setPolicyInfo(state, { payload }) {
      if (!payload) {
        return;
      }
      const { email, orderNumber, signature } = payload;
      state.email = email;
      state.orderNumber = orderNumber;
      state.signature = signature;
    },
    setCustomerInfo(state, { payload }) {
      if (!payload) {
        return;
      }
      const {
        firstName, policyList, applicantEmail, claimList,
      } = payload;
      state.firstName = firstName;
      state.policyList = policyList;
      state.claimList = claimList || [];
      if (applicantEmail) {
        state.email = applicantEmail;
      }
    },
    setRAReasonList(state, { payload }) {
      if (!payload) {
        return;
      }
      state.reasonList = payload;
    },
    // 设置平台  gently treet jing... 现在只判断gently有特殊逻辑
    setPlatform(state, { payload }) {
      if (!payload) {
        return;
      }
      state.platform = payload;
    },
    // 用于记录理赔埋点信息
    setBehaviorData(state, { payload }) {
      if (!payload) {
        return;
      }
      state.behaviorData = { ...payload };
    },
    // 首页获取的claimList在submit claim后需要增加一条
    setClaimList(state, { payload }) {
      if (!payload) {
        return;
      }
      state.claimList.push(payload);
    },
    setSpecialPlatform(state, { payload }) {
      if (!payload) {
        return;
      }
      state.specialPlatform = payload;
    },

  },
});

export const {
  setPolicyInfo, setCustomerInfo, setRAReasonList, setPlatform, setBehaviorData, setClaimList, setSpecialPlatform,
} = policySlice.actions;

export default policySlice.reducer;
